import * as Yup from "yup";

const pattern =
  /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[a-zA-Z0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,15}$/;
const alphaNumPattern = /^[A-Za-z\d\s]*$/;
const validUrl = /^(ftp|http|https):\/\/[^ "]+$/;
const coordinateRegex = /^-?\d+(\.\d+)?$/;

export const LoginSchema = Yup.object().shape({
  email: Yup.string().email().trim().required("email is required"),
  password: Yup.string().required("password is required"),
});

export const EmailSchema = Yup.object().shape({
  email: Yup.string().email().trim().required("email is required"),
});

export const RegisterUserSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "company name cannot be less than 2 characters")
    .required("company name is required"),
  address: Yup.string()
    .min(3, "company address cannot be less than 3 characters")
    .max(40, "company address cannot be more than 40 characters")
    .required("company address is required")
    .matches(
      /^[a-zA-Z0-9 \-,.@()/"'&\\]+$/,
      "company address contains invalid characters"
    ),
  email: Yup.string().email().trim().required("email is required"),
  password: Yup.string()
    .required("password is required")
    .min(8, "password cannot be less than 8 characters")
    .max(15, "password cannot be more than 15 characters")
    .matches(
      pattern,
      "Must contain 8 characters, 1 uppercase, 1 lowercase, 1 number and 1 special character except \\ "
    ),
  state: Yup.string().required("area of economy is required"),
  category: Yup.string().required("category is required"),
  network_manager_email: Yup.string().trim().required("email is required"),
  network_manager_firstname: Yup.string()
    .min(3, "First name cannot be less than 3 characters")
    .required("First name is required")
    .matches(/^[A-Za-z\s]+$/, "cannot contain numbers and special characters"),
  network_manager_lastname: Yup.string()
    .min(3, "Last name cannot be less than 3 characters")
    .required("Last name is required")
    .matches(/^[A-Za-z\s]+$/, "cannot contain numbers and special characters"),
  network_manager_phone: Yup.string()
    .required("phone number is required")
    .max(11, "phone number cannot be more than 11 characters")
    .matches(
      /^(\+?)([0-9\s-]{11})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/,
      "Must be a valid nigerian or international number"
    ),
});

export const AddStaffSchema = Yup.object().shape({
  first_name: Yup.string()
    .min(3, "first name cannot be less than 3 characters")
    .required("first name is required")
    .matches(
      /^[a-zA-Z]+$/,
      "name cannot contain special case characters and numbers"
    ),
  last_name: Yup.string()
    .min(3, "last name cannot be less than 3 characters")
    .required("last name is required")
    .matches(
      /^[a-zA-Z]+$/,
      "name cannot contain special case characters and numbers"
    ),
  email: Yup.string().email().trim().required("email is required"),
  password: Yup.string()
    .required("password is required")
    .min(8, "password cannot be less than 8 characters")
    .max(15, "password cannot be more than 15 characters")
    .matches(
      pattern,
      "Must contain 8 characters, 1 uppercase, 1 lowercase, 1 number and 1 special character except \\ "
    ),
});

export const RegisterAppSchema = Yup.object().shape({
  application_name: Yup.string()
    .min(3, "application name cannot be less than 3 characters")
    .max(60, "application name cannot be more than 60 characters")
    .matches(
      alphaNumPattern,
      "application name cannot contain special case characters"
    )
    .required("application name is required"),
  application_version: Yup.string()
    .min(3, "application version cannot be less than 3 characters")
    .max(60, "application version cannot be more than 60 characters")
    .required("application version is required"),
  device: Yup.string()
    .min(3, "certified device cannot be less than 3 characters")
    .max(60, "certified device cannot be more than 60 characters")
    .matches(
      alphaNumPattern,
      "certified device cannot contain special case characters"
    )
    .required("certified device is required"),
  device_model: Yup.string()
    .min(3, "certified device model cannot be less than 3 characters")
    .max(60, "certified device model cannot be more than 60 characters")
    .required("certified device model is required"),
  posDevice_type: Yup.string()
    .required('Please Select a device type to proceed'),
  device_longitude: Yup.string()
    .matches(coordinateRegex, 'Longitude must be a valid decimal number')
    .test('longitude-range', 'Longitude must be between -180 and 180', val => {
      if (!val) return false;
      const num = parseFloat(val);
      return num >= -180 && num <= 180;
    })
    .required('Longitude is required'),
  device_latitude: Yup.string()
    .matches(coordinateRegex, 'Latitude must be a valid decimal number')
    .test('latitude-range', 'Latitude must be between -90 and 90', val => {
      if (!val) return false;
      const num = parseFloat(val);
      return num >= -90 && num <= 90;
    })
    .required('Latitude is required'),
  merchant_class: Yup.string()
    .max(3, "merchant class cannot be more than 3 digits long")
    .required("merchant class is required"),
  application_bvn: Yup.string()
    .min(11, "application bvn cannot be less than 11 digits long")
    .max(11, "application bvn cannot be more than 11 digits long")
    .required("application bvn is required"),
  application_tin: Yup.string()
    .min(10, 'Application TIN must be at least 10 characters')
    .max(15, 'Application TIN must be at most 15 characters')
    .matches(
      /^(?:\d{10}|\d{3}-\d{6}|\d{8}-\d{4})$/,
      'Application TIN must be either 10 digits, 3 digits + hyphen + 6 digits, or 8 digits + hyphen + 4 digits'
    )
    .required('Application TIN is required')

});

export const RenewalAppSchema = Yup.object().shape({
  application_name: Yup.string()
    .min(3, "device name cannot be less than 3 characters")
    .max(60, "device name cannot be more than 60 characters")
    .matches(
      alphaNumPattern,
      "device name cannot contain special case characters"
    )
    .required("device name is required"),
  application_version: Yup.string()
    .min(3, "device model cannot be less than 3 characters")
    .max(60, "device model cannot be more than 60 characters")
    .required("device model is required"),
});

export const RenewalDeviceSchema = Yup.object().shape({
  application_name: Yup.string()
    .min(3, "application name cannot be less than 3 characters")
    .max(60, "application name cannot be more than 60 characters")
    .matches(
      alphaNumPattern,
      "application name cannot contain special case characters"
    )
    .required("application name is required"),
  application_version: Yup.string()
    .min(3, "application version cannot be less than 3 characters")
    .max(60, "application version cannot be more than 60 characters")
    .required("application version is required"),
});

export const RegisterDeviceSchema = Yup.object().shape({
  device_name: Yup.string()
    .min(3, "device name cannot be less than 3 characters")
    .max(60, "device name cannot be more than 60 characters")
    .matches(
      alphaNumPattern,
      "device name cannot contain special case characters"
    )
    .required("device name is required"),
  device_model: Yup.string()
    .min(3, "device model cannot be less than 3 characters")
    .max(60, "device model cannot be more than 60 characters")
    .matches(
      alphaNumPattern,
      "device model cannot contain special case characters"
    )
    .required("device model is required"),
  manufacturer_name: Yup.string()
    .min(3, "manufacturer's name cannot be less than 3 characters")
    .max(60, "manufacturer's name cannot be more than 60 characters")
    .matches(
      alphaNumPattern,
      "manufacturer's name cannot contain special case characters"
    )
    .required("manufacturer's name is required"),
  application_name: Yup.string()
    .min(3, "application name cannot be less than 3 characters")
    .max(60, "application name cannot be more than 60 characters")
    .matches(
      alphaNumPattern,
      "application name cannot contain special case characters"
    )
    .required("application name is required"),
  version: Yup.string()
    .min(3, "application version cannot be less than 3 characters")
    .max(60, "application version cannot be more than 60 characters")
    .required("application version is required"),
  operating_system: Yup.string()
    .min(3, "operating system cannot be less than 3 characters")
    .max(60, "operating system cannot be more than 60 characters")
    .required("operating system is required"),
  is_card_reader: Yup.bool().required("card reader is required"),
  communication_spec: Yup.string()
    .min(3, "communication spec cannot be less than 3 characters")
    .max(60, "communication spec cannot be more than 60 characters")
    .matches(
      alphaNumPattern,
      "communication spec cannot contain special case characters"
    )
    .required("communication spec is required"),
  camera: Yup.string()
    .min(3, "camera cannot be less than 3 characters")
    .max(60, "camera cannot be more than 60 characters")
    .matches(alphaNumPattern, "camera cannot contain special case characters")
    .required("camera is required"),
  biometric_spec: Yup.string()
    .min(3, "biometric spec cannot be less than 3 characters")
    .max(60, "biometric spec cannot be more than 60 characters")
    .matches(
      alphaNumPattern,
      "biometric spec cannot contain special case characters"
    )
    .required("biometric spec is required"),
  cpu_spec: Yup.string()
    .min(3, "CPU spec cannot be less than 3 characters")
    .max(60, "CPU spec cannot be more than 60 characters")
    .matches(alphaNumPattern, "CPU spec cannot contain special case characters")
    .required("CPU spec is required"),
  keypad_spec: Yup.string()
    .min(3, "keypad spec cannot be less than 3 characters")
    .max(60, "keypad spec cannot be more than 60 characters")
    .matches(
      alphaNumPattern,
      "keypad spec cannot contain special case characters"
    )
    .required("keypad spec is required"),
  display_spec: Yup.string()
    .min(3, "display spec cannot be less than 3 characters")
    .max(60, "display spec cannot be more than 60 characters")
    .matches(
      alphaNumPattern,
      "display spec cannot contain special case characters"
    )
    .required("display spec is required"),
  printer_spec: Yup.string()
    .min(3, "printer spec cannot be less than 3 characters")
    .max(60, "printer spec cannot be more than 60 characters")
    .matches(
      alphaNumPattern,
      "printer spec cannot contain special case characters"
    )
    .required("printer spec is required"),
  power_size: Yup.string()
    .min(3, "power spec cannot be less than 3 characters")
    .max(60, "power spec cannot be more than 60 characters")
    .matches(
      alphaNumPattern,
      "power spec cannot contain special case characters"
    )
    .required("power spec is required"),
  other_spec: Yup.string()
    .min(3, "other spec cannot be less than 3 characters")
    .max(60, "other spec cannot be more than 60 characters")
    .matches(
      alphaNumPattern,
      "other spec cannot contain special case characters"
    )
    .required("other spec is required"),
  multi_application_spec: Yup.string()
    .min(3, "multi application spec cannot be less than 3 characters")
    .max(60, "multi application spec cannot be more than 60 characters")
    .matches(
      alphaNumPattern,
      "multi application spec cannot contain special case characters"
    )
    .required("multi application spec is required"),
    device_longitude: Yup.string()
    .matches(coordinateRegex, 'Longitude must be a valid decimal number')
    .required('Longitude is required'),
    device_latitude: Yup.string()
    .matches(coordinateRegex, 'Longitude must be a valid decimal number')
    .required('Longitude is required'),
    posDevice_type: Yup.string()
    .required('Please Select a device type to proceed'),
});

export const PasswordUpdateSchema = Yup.object().shape({
  oldPassword: Yup.string().required("password is required"),
  newPassword: Yup.string()
    .required("password is required")
    .min(8, "password cannot be less than 8 characters")
    .max(15, "password cannot be more than 15 characters")
    .matches(
      pattern,
      "Must contain 8 characters, 1 uppercase, 1 lowercase, 1 number and 1 special character except \\ "
    ),
});

export const VerifyStaffSchema = Yup.object().shape({
  oldPassword: Yup.string().required("password is required"),
  newPassword: Yup.string()
    .required("password is required")
    .min(8, "password cannot be less than 8 characters")
    .max(15, "password cannot be more than 15 characters")
    .matches(
      pattern,
      "Must contain 8 characters, 1 uppercase, 1 lowercase, 1 number and 1 special character except \\ "
    ),
  confirmPassword: Yup.string()
    .required("please confirm your new password")
    .oneOf([Yup.ref("newPassword"), null], "passwords must match"),
});

export const ResetSchema = Yup.object().shape({
  code: Yup.string()
    .required("code is required")
    .min(6, "code cannot be less than 6 characters")
    .max(6, "code cannot be more than 6 characters"),
  password: Yup.string()
    .required("please enter your new password")
    .min(8, "password cannot be less than 8 characters")
    .max(15, "password cannot be more than 15 characters")
    .matches(
      pattern,
      "Must contain 8 characters, 1 uppercase, 1 lowercase, 1 number and 1 special character except \\ "
    ),
  confirm_password: Yup.string()
    .required("please confirm your new password")
    .oneOf([Yup.ref("password"), null], "passwords must match"),
});

export const NameEnquirySchema = Yup.object().shape({
  sendersFinancialInstitutionCode: Yup.string()
    .required("Institution Code is required")
    .min(6, "Field cannot be less than 6 numbers")
    .max(6, "Field cannot be more than 6 characters"),
  destinationInstitutionCode: Yup.string().required(
    "Destination Code is required"
  ),
  channelCode: Yup.string().required("Channel Code is required"),
  accountNumber: Yup.string().required("Account Number is required"),
});

export const FundTransferSchema = Yup.object().shape({
  sendersFinancialInstitutionCode: Yup.string()
    .required("Institution Code is required")
    .min(6, "Field cannot be less than 6 numbers")
    .max(6, "Field cannot be more than 6 characters"),
  originatorAccountName: Yup.string().required("Account Name is required"),
  originatorAccountNumber: Yup.string().required("Account Number is required"),
  originatorBankVerificationNumber: Yup.string().required(
    "Bank Verification Number is required"
  ),
  originatorKYCLevelr: Yup.string().required("KYC Level is required"),
  paymentReference: Yup.string().required("Payment Reference is required"),
  narration: Yup.string().required("Narration is required"),
  transactionLocation: Yup.string().required(
    "Transaction Location is required"
  ),
  amount: Yup.string().required("Amount is required"),
});

export const StatusQuerySchema = Yup.object().shape({
  sendersFinancialInstitutionCode: Yup.string()
    .min(6, "Field cannot be less than 6 numbers")
    .max(6, "Field cannot be more than 6 characters")
    .required("Institution Code is required"),
  channelCode: Yup.string().required("Channel Code is required"),
});

export const IPFormSchema = Yup.object().shape({
  ip_address: Yup.string().required("IP address is required"),
});

export const TestDataSchema = Yup.object().shape({
  accountNumber: Yup.string()
    .matches(/^-?\d*$/, "account number can only contain numbers")
    .min(10, "account number cannot be less than 10 characters")
    .max(11, "account number cannot be more than 11 characters")
    .required("account number is required"),
  wsdl_url: Yup.string()
    .max(60, "wsdl url cannot be more than 60 characters")
    .matches(validUrl, "must be a valid url")
    .required("wsdl url is required"),
});
